import React, { useRef } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";

import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../../../firebase";
import {
  deleteUser,
  getMessages,
  getUsers,
  sendMessage,
} from "../../../firestore";
import { useState } from "react";
import { useEffect } from "react";
import Constants from "../../../data/Constants";
import Utils from "utils/index";
import { MdChat, MdSend } from "react-icons/md";
import {
  Avatar,
  Button,
  Chip,
  Fab,
  IconButton,
  selectClasses,
} from "@mui/material";
import Navbar from "components/Chat/Navbar";
import { IoChevronBack } from "react-icons/io5";
import { isMobile } from "react-device-detect";
import MessageList from "components/Chat/MessageList";
import ChatList from "components/Chat/ChatList";
import moment from "moment";

// Refer: https://detaysoft.github.io/docs-react-chat-elements/docs/intro for Chat Components

const quickRepliesList = [
  "Hello, Thanks for messaging to Mentostar",
  "We will get back to you shortly",
  "We will try to resolve it as soon as possible",
  "Your query has been resolved",
];

function Chat({ room = "mentee" }) {
  const roomName = room == "mentee" ? "Mentee" : "Mentor";
  const navigate = useNavigate();
  const [user, loading] = useAuthState(auth);
  const { setProgress, setToast } = useOutletContext();

  const [users, setUsers] = useState();
  const [deleteMode, setDeleteMode] = useState(false);
  const [messages, setMessages] = useState();
  const [selectedUser, setSelectedUser] = useState();
  const [quickReplies, setQuickReplies] = useState(quickRepliesList);
  // const [selectedUser, setSelectedUser] = useState();

  const parseUsers = (users) => {
    if (users) {
      const r = [];
      for (let tUser of users) {
        const name = tUser.firstname
          ? tUser.firstname + " " + tUser.lastname
          : "Unknown";
        r.push({
          firebaseId: tUser.firebaseId,
          alt: name,
          title: name,
          avatar: tUser.picture,
          subtitle: tUser.lastMessage,
          date: tUser.lastMessageTime
            ? Utils.timeSince(tUser.lastMessageTime.seconds * 1000)
            : Utils.timeSince(new Date()),
          unread: tUser.unseen,
        });
      }

      return r;
    }

    return;
  };

  const parseMessages = (messages) => {
    const r = [];
    if (messages) {
      for (let msg of messages) {
        r.push({
          position: msg.sentByUser ? "left" : "right",
          type: "text",
          title: msg.sentByUser ? selectedUser.title : "Admin",
          text: msg.message,
          date: moment(msg.createdAt.seconds * 1000),
        });
      }

      return r;
    }
  };

  const handleSend = () => {
    if (selectedUser.draftMessage) {
      sendMessage(room, selectedUser.firebaseId, selectedUser.draftMessage);
      setSelectedUser({ ...selectedUser, draftMessage: "" });
    }
  };

  useEffect(() => {
    setProgress(true);

    async function api() {
      try {
        getUsers(room, (users, error) => {
          if (!error) {
            setProgress(false);
            setUsers(parseUsers(users));
          } else {
            // error
            setProgress(false);
            setToast({ error: true, message: Constants.Error.UNKNOWN });
          }
        });
      } catch (error) {
        // error
        console.log(error);
        setProgress(false);
        setToast({
          error: true,
          message: Utils.CustomErrorMessage(error),
        });
      }
    }
    api();
  }, []);

  useEffect(() => {
    if (selectedUser) {
      getMessages(room, selectedUser.firebaseId, (messages) => {
        setMessages(parseMessages(messages));
      });
    }
  }, [selectedUser]);

  useEffect(() => {
    if (messages) {
      // scrollToBottom();
    }
  }, [messages]);

  return (
    <div className="h-full">
      <div className="flex">
        <h1 className="font-extrabold mx-2 my-4 text-lg flex-grow">
          {roomName} Chat
        </h1>
        <Button
          onClick={() => {
            setDeleteMode(!deleteMode);
          }}
        >
          More
        </Button>
      </div>
      <div className="grid grid-cols-2">
        {users && users.length > 0 ? (
          <div
            className="sm:col-span-1 col-span-2"
            hidden={selectedUser && isMobile}
          >
            <ChatList
              onClick={(u) => {
                setSelectedUser(u);
              }}
              onDelete={(u) => {
                deleteUser(room, u.firebaseId, u);
              }}
              enableDelete={deleteMode}
              users={users}
            />
          </div>
        ) : (
          <div className="flex justify-center flex-col gap-5 items-center text-gray-500 my-24">
            <MdChat size={46} />
            No Messages
          </div>
        )}
        {selectedUser && (
          <div className="sm:col-span-1 col-span-2">
            <Navbar
              left={
                <React.Fragment>
                  <IconButton
                    onClick={() => {
                      setSelectedUser(undefined);
                    }}
                  >
                    <IoChevronBack className="text-white" />
                  </IconButton>
                  <Avatar src={selectedUser.avatar} alt="avatar" className="" />
                </React.Fragment>
              }
              center={<span>{selectedUser.title}</span>}
            />

            {messages && (
              <MessageList messages={messages} sender={selectedUser} />
            )}

            <div className="flex  gap-2 my-2 overflow-y-scroll">
              {/* Empty Chip To fix UI and give a min height */}
              <Chip sx={{ visibility: "hidden", width: "0" }} />
              {quickReplies
                .filter((qp) => {
                  if (selectedUser.draftMessage) {
                    if (
                      qp
                        .toLowerCase()
                        .includes(selectedUser.draftMessage.toLowerCase())
                    ) {
                      return true;
                    }
                  } else {
                    return true;
                  }
                })
                .map((qp) => {
                  return (
                    <Chip
                      label={qp}
                      onClick={() =>
                        setSelectedUser({ ...selectedUser, draftMessage: qp })
                      }
                    />
                  );
                })}
            </div>

            <div className="flex items-center relative">
              <input
                type="text"
                className="w-full  rounded-full p-3 px-6 bg-gray-200 shadow-sm"
                value={selectedUser.draftMessage}
                placeholder="Enter a message"
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    handleSend();
                  }
                }}
                onChange={(e) => {
                  setSelectedUser({
                    ...selectedUser,
                    draftMessage: e.target.value,
                  });
                }}
              />

              <div className="absolute right-0">
                <Fab size="small" color="primary" onClick={handleSend}>
                  <MdSend className="text-white" size={20} />
                </Fab>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Chat;
